import * as React from "react"

export const Base = ({ children, as = "div", ...props }) => {
  return React.createElement(as, props, children)
}
